// extracted by mini-css-extract-plugin
export default {"imageContainer":"ForkChoices__imageContainer","image":"ForkChoices__image","heading":"ForkChoices__heading","smallHeading":"ForkChoices__smallHeading","button":"ForkChoices__button"};